<template>
  <div>
    <nav-header></nav-header>
    <router-view></router-view>
    <nav-footer :email="this.email" :phone="this.phone" :name="this.name" :addr="this.addr"
      :icp="this.icp"></nav-footer>
  </div>
</template>

<script>
import NavFooter from "./../components/NavFooter";
import NavHeader from "./../components/NavHeader";
export default {
  name: "home",
  components: {
    NavFooter,
    NavHeader,
  },
  methods() {
    document.title = "北京邑维智能科技有限公司";
  },
  data() {
    return {
    };
  },
};
</script>
<style lang='' scoped>
</style>